import Warning from "@gaiaherbs/Icons/Warning";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconProps } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        isLoginDisabledForStorefront: state.context.settings.properties.isLoginDisabledForStorefront,
    }
};

const mapDispatchToProps = {};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface GAIAAlertStyles {
    wrapper?: InjectableCss;
    warningIcon?: IconProps;
}

export const alertStyles: GAIAAlertStyles = {
    wrapper: {
        css: css`
            background-color: #faece9;
            display: flex;
            justify-content:center;
            width: 100%;
            padding:29px;
            margin-bottom:26px;
            border-raduis:8px;
            color:#89483B;
        `,
    },
    warningIcon: {
        css: css`
            margin-right:5px;
            height:20px;
            width:20px;
        `
    }
};

const styles = alertStyles;

export const GAIAAlert = ({ isLoginDisabledForStorefront }: Props) => {
    const isLoginDisabled = isLoginDisabledForStorefront === 'True';
    return (
        <>
            {isLoginDisabled ? (
                <StyledWrapper {...styles.wrapper} >
                    <Icon {...styles.warningIcon} src={Warning} />
                    {siteMessage('IFS_Down')}
                </StyledWrapper>
            ) : null}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(GAIAAlert),
    definition: {
        group: "Basic",
        displayName: "IFS Alert",
    },
};

export default widgetModule;
